import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectIntraDayProfileState } from 'widgets/intraDayProfile/store/selectors';
import { WidgetStateWithRequestSymbology } from 'widgets/WidgetSymbologyWarning';

export type IntradayProfilesComponentState = WidgetStateWithRequestSymbology;

export const initialIntraDayProfileComponentState: IntradayProfilesComponentState =
    {};

export const buildIntradayProfilesComponentSlice = () =>
    buildComponentSlice<IntradayProfilesComponentState>(
        WidgetType.INTRA_DAY_PROFILE,
        selectIntraDayProfileState,
        initialIntraDayProfileComponentState
    );

export const useIntradayProfilesComponentSlice = () =>
    useComponentSlice(buildIntradayProfilesComponentSlice());

export type IntradayProfilesComponentPayloadType =
    WidgetComponentSliceActionPayloadType<IntradayProfilesComponentState>;
